export default __webpack_public_path__ + "assets/images/button-bad.a24d528000357fe861031c1eb10a6216.svg";